var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM7.32306 13.5203L13.5596 9.59231C13.9955 9.31775 13.9955 8.68225 13.5596 8.40769L7.32306 4.4797C6.85691 4.1861 6.25 4.52111 6.25 5.07201L6.25 12.928C6.25 13.4789 6.85691 13.8139 7.32306 13.5203Z","fill":"#FF007F"}));
}

Play.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Play;

Play.default = Play;
